module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.utils.getSectionNamesBySorted(_vm.layoutSpecialContentConfig.startPage.sections)), function(item, key) {
    return _c('PageSection', {
      key: key,
      attrs: {
        "section-name": item,
        "config": _vm.layoutSpecialContentConfig.startPage.sections,
        "data-set": _vm.layoutDataSet
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6552a7","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/specialContents/startPage/StartPage.vue
// module id = 89ab4e9ed9913e7435ae
// module chunks = 74